import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DeleteConfirmation, { openDeleteDialog } from './DeleteConfirmation'

const OptionsDropdown = ({campaign_id}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openDelete = () => {
    setAnchorEl(null);
    openDeleteDialog(campaign_id);
  }

  return (
    <React.Fragment>
      <Button size="small"
              className="no-outline" 
              onClick={handleClick}
              endIcon={<ArrowDropDownIcon/>}
              >
        More Actions
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={openDelete}>
          Delete Campaign
        </MenuItem>
      </Menu>
      <DeleteConfirmation />
    </React.Fragment>
  );
}

export default OptionsDropdown